import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import signUpSideImageWeb from 'Assets/img/svg/authentication/signup/signUpSideImageWeb.svg';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		margin: {
			margin: 0,
		},
		display: {
			position: 'absolute',
			right: 0,
		},
		background: {
			borderRadius: '3rem',
			marginLeft: '50% !important',
		},
		side: {
			backgroundImage: `url(${signUpSideImageWeb})`,
			backgroundRepeat: 'no-repeat',
			height: '100vh',
			width: '40%',
		},
		listItems: {
			listStyleType: 'none',
		},
		positionLogo: {
			position: 'absolute',
			width: '300px',
			height: '200px',
			zIndex: 15,
			top: '50%',
			left: '50%',
			margin: '-100px 0 0 -150px',
			objectFit: 'contain',
		},
		sideNavBG: {
			width: '30%',
			position: 'fixed',
			height: '100%',
			zIndex: 1,
			top: 0,
			left: 0,
			backgroundImage: `url(${signUpSideImageWeb})`,
			backgroundRepeat: 'no-repeat',
			backgroundColor: '#7FD6DD',
			overflowX: 'hidden',
		},
		mobileBackground: {
			background: '#7FD6DD',
			height: '147.86px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			margin: '0 1rem',
			textAlign: 'center',
			padding: '.5rem .4rem',
		},
		membershipName: {
			background: '#FEDA37',
			borderRadius: '5rem',
			padding: '1rem 2rem',
		},
	}),
);
